import { Vue } from 'vue-property-decorator';
import tableMixin from '../../../Mixins/table';
import moment from 'moment';
import { capitalize } from 'lodash';
import { isContractEligibleForClinicUse } from '../../../utils/organization';

export default Vue.extend({
  mixins: [tableMixin],
  props: {
    contracts: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      search: '',
      // Controls whether the help dialog for this page is open
      helpOpen: false,
      contractHeaders: [
        { text: 'ID', align: 'center', value: 'id', sortable: true },
        { text: 'Org ID', align: 'center', value: 'organizationId', sortable: true },
        { text: 'Name', align: 'center', value: 'name', sortable: true },
        { text: 'Package', align: 'center', value: 'package', sortable: true },
        { text: 'Type', align: 'center', value: 'packageType', sortable: true },
        { text: 'Size', align: 'center', value: 'packageSize', sortable: true },
        { text: 'Tier', align: 'center', value: 'packageTier', sortable: true },
        { text: 'Internal Note', align: 'center', value: 'internalNote', sortable: false },
        { text: 'Carry Over (sessions)', align: 'center', value: 'carryOverWalletTime', sortable: true },
        { text: 'Sessions Added', align: 'center', value: 'sessionsAdded', sortable: false },
        { text: 'New Total Sessions', align: 'center', value: 'newWalletTime', sortable: true },
        { text: 'Contract Start', align: 'center', value: 'contractStartAt', sortable: true },
        { text: 'Contract End', align: 'center', value: 'contractEndAt', sortable: true },
        { text: 'Actual Start', align: 'center', value: 'actualStartAt', sortable: true },
        { text: 'Actual End', align: 'center', value: 'actualEndAt', sortable: true },
        { text: 'Created', align: 'center', value: 'createdAt', sortable: true },
        { text: 'Updated', align: 'center', value: 'updatedAt', sortable: true },
        { text: 'Clinic Eligible 🏥', align: 'center', value: 'clinicEligible', sortable: false },
        { text: 'Description', align: 'center', value: 'description', sortable: false },
      ],
    };
  },
  methods: {
    formatDateTime(value) {
      if (!value) return '-';
      return moment(value).format('YYYY-MM-DD HH:mm');
    },
    packageTypeLabel(value) {
      // Backend stores time/free/donation; UI displays Bundle/PPU/WoS per locked terminology
      const map = {
        time: 'Bundle',
        free: 'PPU',
        donation: 'WoS',
      };
      return map[value] || value || '-';
    },
    formatTier(value) {
      if (!value) return '-';
      // Convert snake_case enum value to Title Case
      return value
        .split('_')
        .map((word) => capitalize(word))
        .join(' ');
    },
    minutesToSessions(minutes) {
      if (minutes === null || minutes === undefined) return '-';
      // 1 session = 30 minutes
      return Math.floor(minutes / 30);
    },
    sessionsAddedLabel(contract) {
      // Sessions actually added = new total wallet − carry-over wallet.
      // Both values are stored in minutes; convert the delta to sessions.
      // PPU contracts have new_wallet_time = 0 and carry_over = whatever the
      // old Bundle balance was — the delta would be negative (a drain). For
      // those cases we show the raw delta so the reader understands what happened.
      if (contract.newWalletTime === null || contract.newWalletTime === undefined) return '-';
      if (contract.carryOverWalletTime === null || contract.carryOverWalletTime === undefined) return '-';
      const deltaMinutes = contract.newWalletTime - contract.carryOverWalletTime;
      const deltaSessions = Math.floor(deltaMinutes / 30);
      return deltaSessions >= 0 ? `+${deltaSessions}` : `${deltaSessions}`;
    },
    clinicEligibleLabel(contract) {
      // isContractEligibleForClinicUse returns boolean — capitalise the string form for display.
      return capitalize(`${isContractEligibleForClinicUse(contract)}`);
    },
  },
});
